import { FormValidator, ValidationResult } from '../formField/types/form-validator';
import validator from 'validator';

export const PortRangeValidator: (errorMessage: string) => FormValidator = (errorMessage: string) => {
  return async (value: string): Promise<ValidationResult> => {
    // isPort returns true for 0, but 0 is not a valid port
    const isValidPort = val => validator.isPort(val) && val !== '0';

    if (!value) {
      return { valid: true };
    }

    // Check if the value is a valid port range
    const matches = value.split('-');
    if (!matches || matches.length !== 2) {
      return {
        valid: false,
        error: errorMessage,
      };
    }

    // Check if the min and max values are valid ports and min is less than max
    const min = matches[0];
    const max = matches[1];
    if (!isValidPort(min) || !isValidPort(max) || parseInt(min, 10) > parseInt(max, 10)) {
      return {
        valid: false,
        error: errorMessage,
      };
    }

    return {
      valid: true,
    };
  };
};
